// extracted by mini-css-extract-plugin
export default {"CategorySlider":"CategorySlider_CategorySlider__Y9C2k"};